module.exports = __webpack_public_path__ + "media/images/icon-date-1eab9ce6894799f2afdbbc66c83532aa.svg";